module.exports = __webpack_public_path__ + "img/jamie-street-hBzrr6m6-pc-unsplash.9a8bd043.jpg";